// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSIconText/index.less
// module id = 698
// module chunks = 42